import { lazy } from 'react';

// project imports
import Loadable from '../components/Loadable'
import AuthLayout from '../layout/Auth';

// jwt auth
const LoginPage = Loadable(lazy(() => import('../pages/auth/Login')));
// ==============================|| AUTH ROUTING ||============================== //

const LoginRoutes = {
  path: '/',
  element: <AuthLayout/>,
  children: [
    {
      path: '/',
      children: [
        {
          path: '/login',
          element: <LoginPage />
        },
      ]
    }
  ]
};

export default LoginRoutes;
